module.exports = __webpack_public_path__ + "static/media/logo.f780aa3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = 452
// module chunks = 9